import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DemandeNewComponent } from '../demandes/demande-new.component';
import { Me } from '@lib/services/me.service';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'support, [support]',
  templateUrl: './support.component.html'
})
export class SupportComponent {

	private _inline: boolean = false;

    @Input()
    get inline(): any {
        return this._inline;
    }
    set inline(value: any) {
        this._inline = coerceBooleanProperty(value);
    }

	constructor(public readonly me: Me,
                private readonly dialog: MatDialog) {}

	openDemande () {
		this.dialog.open(DemandeNewComponent, {width: '1080px'});
	}
}